import React from 'react';

const AccountingReports = () => {
	return <div></div>;
};

export default AccountingReports;
